import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isLoggedIn } from '@/auth/token';
import { guestForkPaths } from '../guestFork';

export default function ForkModal({ currentName, onConfirm, onClose }: { currentName: string; onConfirm: (name: string) => void; onClose: () => void }) {
  const loc = useLocation();
  const [name, setName] = useState(`${currentName} (fork)`);

  if (!isLoggedIn()) {
    const { register, login } = guestForkPaths(loc.pathname + loc.search);
    return (
      <div data-testid="fork-auth-modal" className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={onClose}>
        <div className="w-[420px] max-w-[92vw] bg-surface border border-border rounded-xl p-5" onClick={(e) => e.stopPropagation()}>
          <div className="flex items-center gap-2 mb-3">
            <i className="ri-git-branch-line text-accent" />
            <h3 className="text-sm font-semibold text-textp">Create an account to fork</h3>
          </div>
          <p className="text-xs text-texts mb-4 leading-relaxed">
            Forking copies this pipeline into your workspace. Sign up to keep it. New accounts get 20 free hosted runs.
          </p>
          <div className="flex items-center justify-end gap-2">
            <button onClick={onClose} className="text-texts hover:text-textp text-sm px-3 py-1.5 rounded-md whitespace-nowrap">Cancel</button>
            <Link to={login} className="text-texts hover:text-textp text-sm px-3 py-1.5 rounded-md whitespace-nowrap">Sign in</Link>
            <Link
              data-testid="fork-register"
              to={register}
              className="bg-accent hover:bg-accent-hover text-accent-text text-sm px-3 py-1.5 rounded-md whitespace-nowrap"
            >
              Create account
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={onClose}>
      <div className="w-[420px] max-w-[92vw] bg-surface border border-border rounded-xl p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 mb-3">
          <i className="ri-git-branch-line text-accent" />
          <h3 className="text-sm font-semibold text-textp">Fork this pipeline?</h3>
        </div>
        <p className="text-xs text-texts mb-3">Give your fork a name:</p>
        <input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full bg-bg border border-border rounded-md px-3 py-2 text-sm text-textp outline-none focus:border-accent"
        />
        <div className="flex items-center justify-end gap-2 mt-4">
          <button onClick={onClose} className="text-texts hover:text-textp text-sm px-3 py-1.5 rounded-md whitespace-nowrap">Cancel</button>
          <button onClick={() => onConfirm(name)} className="bg-accent hover:bg-accent-hover text-accent-text text-sm px-3 py-1.5 rounded-md whitespace-nowrap">Fork</button>
        </div>
      </div>
    </div>
  );
}
